module.exports = "- Been writing JSX full-time for a year now. Still hate it.\n\n- I've changed my mind about JSX - it's pretty awesome.\n"


//////////////////
// WEBPACK FOOTER
// ./src/slides/07_jsx/notes_5.md
// module id = 1503
// module chunks = 0